import { styled } from '@mui/material/styles';
import { ListItemIcon, ListItemButton } from '@mui/material';

export const StyledNavItem = styled((props) => <ListItemButton disableGutters {...props} />)(({ theme }) => ({
  ...theme.typography.body2,
  position: 'relative',
  minHeight: 40,
  padding: theme.spacing(0.875, 1.5),
  marginInline: theme.spacing(1),
  marginBlock: 2,
  color: theme.palette.text.secondary,
  borderRadius: 8,
  fontWeight: 500,
  fontSize: 13.5,
  transition: 'background-color .15s ease, color .15s ease',
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.text.primary,
  },
  '&.active': {
    backgroundColor: theme.palette.primary.lighter,
    color: theme.palette.primary.dark,
    fontWeight: 600,
    '&::before': {
      content: '""',
      position: 'absolute',
      left: -4,
      top: 8,
      bottom: 8,
      width: 3,
      borderRadius: 4,
      backgroundColor: theme.palette.primary.main,
    },
    '& .MuiListItemIcon-root': { color: theme.palette.primary.main },
  },
}));

export const StyledNavItemIcon = styled(ListItemIcon)({
  width: 20,
  height: 20,
  minWidth: 20,
  marginRight: 12,
  color: 'inherit',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
